import { useSearchParams } from "react-router-dom";
import ReportVocEmssionTable from "./components/ReportVocEmssionTable";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

let isRequestCompany: string | null = null;
const ReportVocEmission = () => {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const profile = profileStore(useShallow((state) => state.profile));
  const requestProfile = profileStore(useShallow((state) => state.requestProfile));

  useEffect(() => {
    if (profile?.company && profile.company.length > 0 && companyId && (!isRequestCompany || isRequestCompany != companyId)) {
      const findSlot = profile.company.find((item) => item._id == companyId);
      if (findSlot) {
        requestProfile({ companyId: companyId });
        isRequestCompany = companyId;
      } else {
        window.location.pathname = "/unauthorized";
      }
    }
  }, [profile?.company]);
  return <ReportVocEmssionTable />;
};

export default ReportVocEmission;
